import { Component } from '@angular/core';
import { PortalHomeProfilesComponent } from '../../../portal-home-profiles/portal-home-profiles.component';
import { PortalLoginComponent } from '../../../portal-login/portal-login.component';
import { PortalProfileComponent } from '../../../portal-profile/portal-profile.component';
@Component({
  selector: 'app-component-test-page',
  imports: [PortalLoginComponent, PortalHomeProfilesComponent, PortalProfileComponent],
  templateUrl: './component-test-page.component.html',
  styleUrl: './component-test-page.component.css',
})
export class ComponentTestPageComponent {}
